export default "__VITE_ASSET__3R1FMg2g__"